import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  buttonProgress: {
    left: 0,
    margin: 'auto',
    position: 'absolute',
    right: 0,
  },
});

export default useStyles;
